<basket-notification-bar class="block"></basket-notification-bar>

@if (model) {
<cms-product-view-layout [variant]="model.ppLayoutVariant"
                         [product]="model"
                         [parent]="parent" />
}